module.exports = __webpack_public_path__ + "static/media/P1-Busqueda-no-encontrada.db1f31ab.png";